import ExpiredLicensesList from './component'
export default ExpiredLicensesList
